import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';
import API from '../api'; // ensure API import present

export default function Dashboard() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [officeName, setOfficeName] = useState('');
  // Fetch office name on mount
  useEffect(() => {
    async function fetchOffice() {
      try {
        const resp = await API.get('profile/me/');
        if (resp.data && resp.data.office_name) {
          setOfficeName(resp.data.office_name);
        }
      } catch (e) {
        setOfficeName('');
      }
    }
    fetchOffice();
  }, []);

  const changeLanguage = async (lang) => {
    if (!i18n) return;
    try {
      // persist language to DB
      await API.post('profile/me/', { language: lang });
    } catch (e) {
      // ignore write errors (still change UI language)
    }
    i18n.changeLanguage(lang);
    // store a client-side fallback so pages opened without auth (e.g. print popup)
    try { localStorage.setItem('preferred_language', lang); } catch (e) { /* ignore */ }
  };

  return (
    <div className="dashboard page-container">
      <div style={{
        margin: '0 auto 24px auto',
        width: '100%',
        maxWidth: 700,
        minHeight: 180,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
        position: 'relative',
      }}>
        {/* Left circle */}
        <div style={{
          width: 100,
          height: 100,
          borderRadius: '50%',
          overflow: 'hidden',
          boxShadow: '0 0 24px 6px #ffe066, 0 0 0 8px #fff',
          background: 'radial-gradient(circle at 60% 40%, #fff 60%, #ffe066 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          animation: 'spin 6s linear infinite',
        }}>
          <img src="/dl.png" alt="logo-left" style={{
            width: '90%',
            height: '90%',
            objectFit: 'cover',
            borderRadius: '50%',
            filter: 'drop-shadow(0 0 8px #ffe066)',
          }} />
        </div>
        {/* Center text */}
        <div style={{
          flex: 1,
          textAlign: 'center',
          position: 'relative',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
          }}>
            <span style={{
              fontWeight: 'bold',
              fontSize: '2.2rem',
              background: 'linear-gradient(90deg, #fff200 0%, #ff9800 30%, #ff5722 60%, #d32f2f 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              padding: '8px 24px',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
            }}>{t('Delivery Management')}</span>
            {officeName && (
              <span style={{
                fontWeight: 'bold',
                fontSize: '1.4rem',
                background: 'linear-gradient(90deg, #fff200 0%, #ff9800 30%, #ff5722 60%, #d32f2f 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                textFillColor: 'transparent',
                marginTop: '4px',
                padding: '6px 18px',
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
              }}>{officeName}</span>
            )}
          </div>
        </div>
        {/* Right circle */}
        <div style={{
          width: 100,
          height: 100,
          borderRadius: '50%',
          overflow: 'hidden',
          boxShadow: '0 0 24px 6px #ffe066, 0 0 0 8px #fff',
          background: 'radial-gradient(circle at 40% 60%, #fff 60%, #ffe066 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          animation: 'spin 6s linear infinite reverse',
        }}>
          <img src="/dl.png" alt="logo-right" style={{
            width: '90%',
            height: '90%',
            objectFit: 'cover',
            borderRadius: '50%',
            filter: 'drop-shadow(0 0 8px #ffe066)',
          }} />
        </div>
        {/* Add keyframes for spin animation */}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>

      {/* Language Selector */}
      <div className="language-selector">
          <button onClick={() => changeLanguage('ar')}>عربي</button>
          <button onClick={() => changeLanguage('en')}>EN</button>
          <button onClick={() => changeLanguage('fr')}>FR</button>
      </div>

      {/* Navigation Buttons */}
    <div className="buttons">
      <button onClick={() => navigate('/customers')} style={{
        background: 'linear-gradient(90deg, #ff9800, #ff5722)',
        color: 'white',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        margin: '0 6px',
        padding: '8px 18px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
      }}>{t('Customers')}</button>
      <button onClick={() => navigate('/drivers')} style={{
        background: 'linear-gradient(90deg, #d32f2f, #ff9800)',
        color: 'white',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        margin: '0 6px',
        padding: '8px 18px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
      }}>{t('Drivers')}</button>
      <button onClick={() => navigate('/orders')} style={{
        background: 'linear-gradient(90deg, #ff5722, #fff200)',
        color: 'white',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        margin: '0 6px',
        padding: '8px 18px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
      }}>{t('Orders')}</button>
      <button onClick={() => navigate('/whatsapp-notifications')} style={{
        background: 'linear-gradient(90deg, #fff 0%, #ffe066 50%, #ff9800 100%)',
        color: '#d32f2f',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        margin: '0 6px',
        padding: '8px 18px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
      }}>
        🟠 {t('WhatsApp Notifications')}
      </button>
      <button onClick={() => navigate('/tracking')} style={{
        background: 'linear-gradient(90deg, #fff 0%, #ffe066 50%, #ff9800 100%)',
        color: '#d32f2f',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        margin: '0 6px',
        padding: '8px 18px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
      }}>
        📍 {t('Order Tracking')}
      </button>
    </div>

      {/* Removed Search Orders button; filtering is now in Orders page */}
      {/* Logout Button */}
      <div className="logout">
          <button onClick={() => {
              localStorage.removeItem('token');
              navigate('/login');
          }}>{t('Logout')}</button>
      </div>
    </div>
  );
}

